import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { fetchOPDReport } from "../../../store/slices/reportSlice";
import OPDReportsList from "./OPDReportsList";
import Breadcrumbs from "../../../components/common/Breadcrumbs";
import MainLayout from "../../../components/layout/MainLayout";

const OPDReports = () => {
  const dispatch = useDispatch();
  const { opdReport, opdConsultants, opdConversions, isLoading } = useSelector((state) => state.reports);

  const [showFilters, setShowFilters] = useState(false);
  const [tempFilters, setTempFilters] = useState({
    consultant: "",
    opdType: "",
    startDate: "",
    endDate: ""
  });
  const [activeFilters, setActiveFilters] = useState({
    consultant: "",
    opdType: "",
    startDate: "",
    endDate: ""
  });

  const selectStyles = {
    control: (base) => ({
      ...base,
      minHeight: '31px',
      height: '31px',
      fontSize: '0.8125rem',
      borderRadius: '0.375rem',
      borderColor: '#d9dee3',
      '&:hover': { borderColor: '#d9dee3' }
    }),
    valueContainer: (base) => ({ ...base, padding: '0 8px', height: '31px' }),
    input: (base) => ({ ...base, margin: '0', padding: '0' }),
    indicatorsContainer: (base) => ({ ...base, height: '31px' }),
    dropdownIndicator: (base) => ({ ...base, padding: '2px' }),
    clearIndicator: (base) => ({ ...base, padding: '2px' }),
    menu: (base) => ({ ...base, fontSize: '0.8125rem' }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? '#666ee8' : state.isFocused ? '#f5f5f9' : 'white',
      color: state.isSelected ? 'white' : '#566a7f',
      cursor: 'pointer',
    })
  };

  const consultantOptions = [
    { value: "", label: "All Consultants" },
    ...opdConsultants.map(c => ({ value: c.consultant_name, label: `Dr. ${c.consultant_name}` }))
  ];

  const typeOptions = [
    { value: "", label: "All Types" },
    { value: "New", label: "New Cases" },
    { value: "Follow-up", label: "Follow-up" },
  ];

  useEffect(() => {
    dispatch(fetchOPDReport(activeFilters));
  }, [dispatch, activeFilters]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setTempFilters(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    setActiveFilters({ ...tempFilters });
  };

  const handleClear = () => {
    const cleared = {
      consultant: "",
      opdType: "",
      startDate: "",
      endDate: ""
    };
    setTempFilters(cleared);
    setActiveFilters(cleared);
  };

  return (
    <MainLayout>
      <Breadcrumbs />
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="mb-0">OPD Summary Reports</h4>
          <div>
            <button
              className={`btn btn-sm ${showFilters ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setShowFilters(!showFilters)}
            >
              <i className="ri-filter-line me-1"></i> {showFilters ? 'Hide Filters' : 'Filters'}
            </button>
          </div>
        </div>

        {/* Filters Accordion */}
        <div className={`collapse ${showFilters ? 'show' : ''}`}>
          <div className="px-4 py-3">
            <div className="card shadow-sm border">
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-md-3">
                    <label className="form-label small fw-bold">Consultant</label>
                    <Select
                      options={consultantOptions}
                      styles={selectStyles}
                      value={consultantOptions.find(opt => opt.value === tempFilters.consultant)}
                      onChange={(opt) => setTempFilters(prev => ({ ...prev, consultant: opt.value }))}
                      placeholder="Select Consultant"
                      isSearchable
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label small fw-bold">Assessment Type</label>
                    <Select
                      options={typeOptions}
                      styles={selectStyles}
                      value={typeOptions.find(opt => opt.value === tempFilters.opdType)}
                      onChange={(opt) => setTempFilters(prev => ({ ...prev, opdType: opt.value }))}
                      placeholder="Select Type"
                      isSearchable
                    />
                  </div>
                  <div className="col-md-2">
                    <label className="form-label small fw-bold">Start Date</label>
                    <input type="date" name="startDate" className="form-control form-control-sm" value={tempFilters.startDate} onChange={handleFilterChange} />
                  </div>
                  <div className="col-md-2">
                    <label className="form-label small fw-bold">End Date</label>
                    <input type="date" name="endDate" className="form-control form-control-sm" value={tempFilters.endDate} onChange={handleFilterChange} />
                  </div>
                  <div className="col-md-2 d-flex align-items-end gap-2">
                    <button className="btn btn-sm btn-label-secondary w-50" onClick={handleClear}>Clear</button>
                    <button className="btn btn-sm btn-primary w-50" onClick={handleSubmit}>Submit</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <OPDReportsList
          data={opdReport}
          consultants={opdConsultants}
          conversions={opdConversions}
          filters={activeFilters}
          isLoading={isLoading}
        />
      </div>
    </MainLayout>
  );
};

export default OPDReports;
